export default __webpack_public_path__ + "static/media/KelleyHouse.c6336d13.jpg";